import { Component } from '@angular/core';
import { LocaleService } from '../shared/services/locale.service';
import { ViewportService } from '../shared/services/viewport.service';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
	constructor(public locale: LocaleService, public viewport: ViewportService) {}

	year: number = new Date().getFullYear();

	onCallHelpline(number) {
		if (this.viewport.type === 'mobile') {
			window.location.href = `tel:${number}`;
		}
	}
}
